import { Rule } from "@with-nx/simple-ui/atoms";
import { ReusableSection } from "@with-nx/simple-ui/atoms";
import { CatalogLayout } from "@with-nx/simple-ui/organisms";
import { Col, Row } from "antd";

import LegalMenuDesktop from "../../components/w/LegalMenuDesktop";
import { TermsAndConditions } from "../../components/w/terms-and-conditions";

export default function Page() {
  return (
    <CatalogLayout
      footerNoAngle
      title="Broadway Media - Terms and Conditions"
      description="This Terms of Use document was last updated on December 17, 2020"
    >
      <ReusableSection>
        <div className="container mx-auto max-w-7xl">
          <Row gutter={[36, 18]} justify="space-between">
            <Col xs={24} sm={24} md={24} lg={6} xl={6}>
              <LegalMenuDesktop />
            </Col>
            <Col xs={24} sm={24} md={24} lg={18} xl={18}>
              <Rule rule="hs" color="var(--font1)" display="block" bottom={24}>
                Terms of Use
              </Rule>
              <Rule rule="ls" color="var(--font3)" display="block" bottom={24}>
                This Terms of Use document was last updated on December 17, 2020
              </Rule>

              <TermsAndConditions />
            </Col>
          </Row>
        </div>
      </ReusableSection>
    </CatalogLayout>
  );
}
